export interface ComicCategory {
  id: string;
  name: string;
}

export const categories: ComicCategory[] = [
  { id: 'romance', name: '恋爱' },
  { id: 'campus', name: '校园' },
  { id: 'daily', name: '日常' },
  { id: 'healing', name: '治愈' },
  { id: 'fantasy', name: '奇幻' },
  { id: 'action', name: '热血' },
];